// extracted by mini-css-extract-plugin
export default {"container":"Section04_container__SqLwK","Cyber":"Section04_Cyber__93I0o","Image":"Section04_Image__xt4CV"};